import { AlgorithmSubscribeType, AlgorithmType } from '../Algorithm';
export class HeatmapCache {
    constructor(dataCache) {
        this._storageByAlgorithmId = new Map();
        this._subscribers = new Map();
        this._dataCache = dataCache;
    }
    ProcessAlgorithm(algorithmMessage) {
        const algorithmId = algorithmMessage.AlgorithmId;
        let storageByInstrumentListId = this._storageByAlgorithmId.get(algorithmId);
        if (isNullOrUndefined(storageByInstrumentListId)) {
            storageByInstrumentListId = new StorageByInstrumentListId();
            this._storageByAlgorithmId.set(algorithmId, storageByInstrumentListId);
        }
        let storageByInstrumentTradableId = storageByInstrumentListId.get(algorithmMessage.InstrumentListId);
        if (isNullOrUndefined(storageByInstrumentTradableId)) {
            storageByInstrumentTradableId = new StorageByInstrumentTradableId();
            storageByInstrumentListId.set(algorithmMessage.InstrumentListId, storageByInstrumentTradableId);
        }
        for (let i = 0; i < algorithmMessage.HeatmapAlgorithmData.length; i++) {
            const data = algorithmMessage.HeatmapAlgorithmData[i];
            if (data.IsDelayed) {
                storageByInstrumentTradableId.setDelayedData(data.TradableId, data);
            }
            else {
                storageByInstrumentTradableId.setRealTimeData(data.TradableId, data);
            }
        }
        const subscribers = this._subscribers.get(algorithmId);
        if (!isNullOrUndefined(subscribers)) {
            for (let i = 0; i < subscribers.length; i++) {
                subscribers[i]();
            }
        }
    }
    Clear() {
        this._storageByAlgorithmId.clear();
    }
    processSubscription(instrumentListId, isSubscribe, update) {
        const algorithmId = this.findAlgorithmId(instrumentListId);
        if (!isNullOrUndefined(algorithmId)) {
            if (isSubscribe) {
                let subscribers = this._subscribers.get(algorithmId);
                if (isNullOrUndefined(subscribers)) {
                    subscribers = [];
                    this._subscribers.set(algorithmId, subscribers);
                }
                subscribers.push(update);
            }
            else {
                const subscribers = this._subscribers.get(algorithmId);
                if (!isNullOrUndefined(subscribers)) {
                    for (let i = 0; i < subscribers.length; i++) {
                        if (subscribers[i] === update) {
                            subscribers.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            this._dataCache.AlgorithmCache.SubscriptionHandler(isSubscribe ? AlgorithmSubscribeType.Subscribe : AlgorithmSubscribeType.Unsubscribe, algorithmId, this);
        }
    }
    getData(instrumentListId, instrument) {
        const algorithmId = this.findAlgorithmId(instrumentListId);
        if (isNullOrUndefined(algorithmId)) {
            return undefined;
        }
        const storageByInstrumentListId = this._storageByAlgorithmId.get(algorithmId);
        if (isNullOrUndefined(storageByInstrumentListId)) {
            return undefined;
        }
        const storageByTradableId = storageByInstrumentListId.get(instrumentListId);
        if (isNullOrUndefined(storageByTradableId)) {
            return undefined;
        }
        const entitlmentSystemCache = this._dataCache.EntitlementManager;
        const rt = entitlmentSystemCache.IsExistSubsctiption(false, instrument.Id, instrument.getInstrumentGroupId(), instrument.TradingExchange); // TODO
        const delayed = entitlmentSystemCache.IsExistSubsctiption(true, instrument.Id, instrument.getInstrumentGroupId(), instrument.TradingExchange); // TODO
        if (rt) {
            return Object.assign({}, storageByTradableId.getRealTimeData(instrument.InstrumentTradableID));
        }
        else if (delayed) {
            return Object.assign({}, storageByTradableId.getDelayedData(instrument.InstrumentTradableID));
        }
        else {
            return undefined;
        }
    }
    findAlgorithmId(instrumentListId) {
        if (isNullOrUndefined(instrumentListId)) {
            return undefined;
        }
        const algorithmCache = this._dataCache.AlgorithmCache;
        if (isNullOrUndefined(algorithmCache)) {
            return undefined;
        }
        const algorithms = algorithmCache.getAlgorithmsByAlgorithmType(AlgorithmType.Heatmap);
        for (let i = 0; i < algorithms.length; i++) {
            if (algorithms[i].InstrumentGroupIDs.indexOf(instrumentListId) !== -1) {
                return algorithms[i].AlgorithmId;
            }
        }
        return undefined;
    }
}
class StorageByInstrumentListId {
    constructor() {
        this._storageByInstrumentListId = new Map();
    }
    get(instrumentListId) {
        return this._storageByInstrumentListId.get(instrumentListId);
    }
    set(instrumentListId, storageByInstrumentTradableId) {
        this._storageByInstrumentListId.set(instrumentListId, storageByInstrumentTradableId);
    }
}
class StorageByInstrumentTradableId {
    constructor() {
        this._delayedDataByTradableId = new Map();
        this._realTimeDataByTradableId = new Map();
    }
    getDelayedData(tradableId) {
        return this._delayedDataByTradableId.get(tradableId);
    }
    setDelayedData(tradableId, data) {
        this._delayedDataByTradableId.set(tradableId, data);
    }
    getRealTimeData(tradableId) {
        return this._realTimeDataByTradableId.get(tradableId);
    }
    setRealTimeData(tradableId, data) {
        this._realTimeDataByTradableId.set(tradableId, data);
    }
}
